import { getAPI } from "../utils/api"
import endpoints from "../utils/endpoints"


export const getTransactionAnalytics = (paramsOrCallback, callBackOrError, maybeError) => {
    const hasParams = typeof paramsOrCallback === "object" && paramsOrCallback !== null;
    const params = hasParams ? paramsOrCallback : {};
    const callBack = hasParams ? callBackOrError : paramsOrCallback;
    const errorCallback = hasParams ? maybeError : callBackOrError;

    return (dispatch) => {
        getAPI(
            endpoints?.GET_TRANSACTIONS_ANALYTICS,
            params,
            (data) => {
                callBack(data);
            },
            (err) => {
                errorCallback(err);
            },
            localStorage.getItem('token')
        );
    };
};

export const getAllTransactions = (paramsOrCallback, callBackOrError, maybeError) => {
    const hasParams = typeof paramsOrCallback === "object" && paramsOrCallback !== null;
    const params = hasParams ? paramsOrCallback : {};
    const callBack = hasParams ? callBackOrError : paramsOrCallback;
    const errorCallback = hasParams ? maybeError : callBackOrError;

    return (dispatch) => {
        getAPI(
            endpoints?.GET_ALL_TRANSACTIONS,
            params,
            (data) => {
                callBack(data);
            },
            (err) => {
                errorCallback(err);
            },localStorage.getItem('token')
        );
    }
}